import { Modal } from "antd";
import React, { memo } from "react";
import { useSelector } from "react-redux";

const SSTModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );
  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="SST Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID </div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Patient Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
                <div>Partner</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_full_name}
                </div>
                <div>Partner Age</div>
                <div>{activePatientJourneyModuleDetails?.partner_dob}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Patient Registration & Basic info from patient
              </div>
              <div className="details-table">
                <div>Male Partner</div>
                <div>{activePatientJourneyModuleDetails?.male_partner}</div>
                <div>Age (Male)</div>
                <div>{activePatientJourneyModuleDetails?.age_male}</div>
                <div>Female Partner</div>
                <div>{activePatientJourneyModuleDetails?.female_partner}</div>
                <div>Age (Female)</div>
                <div>{activePatientJourneyModuleDetails?.age_female}</div>
                <div>Pt. ID</div>
                <div>{activePatientJourneyModuleDetails?.pt_id}</div>
                <div>Collection</div>
                <div>{activePatientJourneyModuleDetails?.collections}</div>
                <div>Collections Other</div>
                <div>
                  {activePatientJourneyModuleDetails?.collections_other}
                </div>
                <div>Complete Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.complete_collection}
                </div>
                <div>Rec.No.</div>
                <div>{activePatientJourneyModuleDetails?.rec_no}</div>
                <div>Date</div>
                <div>{activePatientJourneyModuleDetails?.date}</div>
                <div>Referring clinic/clinician</div>
                <div>{activePatientJourneyModuleDetails?.refer_clinic}</div>
                <div>Abstinence Period (Days)</div>
                <div>
                  {activePatientJourneyModuleDetails?.abstinance_period}
                </div>
                <div>Method Of Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.method_collection}
                </div>
                <div>Collection time(CT)</div>
                <div>{activePatientJourneyModuleDetails?.collection_time}</div>
                <div>Assay time (AT)</div>
                <div>{activePatientJourneyModuleDetails?.assay_time}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Preliminary Semen Analysis</div>
              <div className="details-table">
                <div>Ejaculate volume</div>
                <div>{activePatientJourneyModuleDetails?.ejaculate_volume}</div>
                <div>Liquification Time</div>
                <div>
                  {activePatientJourneyModuleDetails?.liquification_time}min
                </div>
                <div>Visual appearance</div>
                <div>
                  {activePatientJourneyModuleDetails?.visual_appeareance}
                </div>
                <div>Viscosity</div>
                <div>{activePatientJourneyModuleDetails?.viscosity}</div>
                <div>Pus cells/Leucocytes</div>
                <div>
                  {activePatientJourneyModuleDetails?.pus_cells_leucocytes}/hpf
                </div>
                <div>Debries</div>
                <div>{activePatientJourneyModuleDetails?.debries}</div>
                <div>Normal forms</div>
                <div>{activePatientJourneyModuleDetails?.normal_forms}</div>
                <div>Concentration</div>
                <div>
                  {activePatientJourneyModuleDetails?.concentration}Million/ml
                </div>
                <div>Motility</div>
                <div>{activePatientJourneyModuleDetails?.motility}</div>
                <div>Preparation Method</div>
                <div>
                  {activePatientJourneyModuleDetails?.preparation_method}
                </div>
                <div>Culturing days</div>
                <div>{activePatientJourneyModuleDetails?.culturing_days}</div>
                <div>Culture media</div>
                <div>{activePatientJourneyModuleDetails?.culture_media}</div>
                <div>Batch No.</div>
                <div>{activePatientJourneyModuleDetails?.batch_no}</div>
                <div>Expiry Date</div>
                <div>{activePatientJourneyModuleDetails?.exp_date}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Subsequent Semen Analysis</div>
              <div className="details-table">
                <div>Interpretation</div>
                <div>{activePatientJourneyModuleDetails?.interpretation}</div>
                <div>Interpretation Other</div>
                <div>
                  {activePatientJourneyModuleDetails?.interpretation_other}
                </div>
                <div>Examination done by</div>
                <div>
                  {activePatientJourneyModuleDetails?.examination_done_by}
                </div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
              {/* <h4 className='mt-3 mb-2'>1.Concentration</h4>
              <div className="details-table">
                <div>Preliminary</div>
                <div>{activePatientJourneyModuleDetails?.concentration_prelim}</div>
                <div>Post wash</div>
                <div>{activePatientJourneyModuleDetails?.concentration_post}</div>
                <div>After 24 hrs.</div>
                <div>{activePatientJourneyModuleDetails?.concentration_after_24}</div>
                <div>After 48 hrs.</div>
                <div>{activePatientJourneyModuleDetails?.concentration_after_48}</div>
                <div>After 72 hrs.</div>
                <div>{activePatientJourneyModuleDetails?.concentration_after_72}</div>
              </div>
              <h4 className='mt-3 mb-2'>2.Motility</h4>
              <div className="details-table">
                <div>Preliminary</div>
                <div>{activePatientJourneyModuleDetails?.motility_prelim}</div>
                <div>Post wash</div>
                <div>{activePatientJourneyModuleDetails?.motility_post}</div>
                <div>After 24 hrs.</div>
                <div>{activePatientJourneyModuleDetails?.motility_after_24}</div>
                <div>After 48 hrs.</div>
                <div>{activePatientJourneyModuleDetails?.motility_after_48}</div>
                <div>After 72 hrs.</div>
                <div>{activePatientJourneyModuleDetails?.motility_after_72}</div>
              </div> */}
            </div>
          </div>
          <div className="table_wrapper mt-3">
            <h3>Subsequent Semen Analysis</h3>
          </div>
          <div className="custom_table_wrap mb-3">
            <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Perameter</th>
                    <th className="text-center">Preliminary</th>
                    <th className="text-center">Post wash</th>
                    <th className="text-center">After 24 hrs.</th>
                    <th className="text-center">After 48 hrs.</th>
                    <th className="text-center">After 72 hrs.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Concentration</td>
                    <td>
                      {" "}
                      {activePatientJourneyModuleDetails?.concentration_prelim}
                    </td>
                    <td>
                      {activePatientJourneyModuleDetails?.concentration_post}
                    </td>
                    <td>
                      {
                        activePatientJourneyModuleDetails?.concentration_after_24
                      }
                    </td>
                    <td>
                      {
                        activePatientJourneyModuleDetails?.concentration_after_48
                      }
                    </td>
                    <td>
                      {
                        activePatientJourneyModuleDetails?.concentration_after_72
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>Motility</td>
                    <td>
                      {activePatientJourneyModuleDetails?.motility_prelim}
                    </td>
                    <td>{activePatientJourneyModuleDetails?.motility_post}</td>
                    <td>
                      {activePatientJourneyModuleDetails?.motility_after_24}
                    </td>
                    <td>
                      {activePatientJourneyModuleDetails?.motility_after_48}
                    </td>
                    <td>
                      {activePatientJourneyModuleDetails?.motility_after_72}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default memo(SSTModal);
